export const CheckoutDataKey = 'CheckoutData';
export const UpdateSubscriptionDataKey = 'UpdateSubData';
